import { useContext, useEffect } from 'react';
import Helmet from 'react-helmet';
import { IBeamerConfig } from './updates';
import { SessionContext } from '../../../../../utility/useSession';
import { options } from '../../../../../utility/options';

interface BeamerHelmetProps {
    url?: string;
}

const BeamerHelmet = ({ url = "https://app.getbeamer.com/js/beamer-embed.js" }: BeamerHelmetProps) => {
    const session = useContext(SessionContext);
    const beamer_config: IBeamerConfig = {
        product_id: options.beamerProductId,
        selector: ".launchBeamer",
        display: "right",
        top: 0,
        right: 0,
        button_position: 'bottom-right',
        language: 'EN',
        filter: 'admin',
        lazy: false,
        alert: true,
        multi_user: true,
        bounce: false,
        //---------------Visitor Information---------------
        user_id: session?.current?.site?.user.uuid,
    };

    useEffect(() => {
        window.beamer_config = beamer_config;
    }, [beamer_config]);

    return (
        <Helmet>
            <script src={url} defer></script>
        </Helmet>
    );
};

export default BeamerHelmet;